var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NoWifi component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNoWifi extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.28043 2.45139C1.99043 2.16139 1.51043 2.16139 1.22043 2.45139C0.93043 2.74139 0.93043 3.22139 1.22043 3.51139L19.5304 21.8214C19.8204 22.1114 20.3004 22.1114 20.5904 21.8214C20.8804 21.5314 20.8804 21.0514 20.5904 20.7614L14.2104 14.3814C14.6204 14.6014 15.0004 14.8914 15.3304 15.2314C15.6204 15.5314 16.0904 15.5314 16.3904 15.2414C16.6904 14.9514 16.6904 14.4814 16.4004 14.1814C15.8204 13.5914 15.1304 13.1214 14.3704 12.7914C13.6604 12.4914 12.9004 12.3314 12.1404 12.3014L9.86043 10.0214C10.5404 9.87139 11.2304 9.79139 11.9304 9.79139C13.1804 9.79139 14.4204 10.0414 15.5704 10.5214C16.7204 11.0014 17.7704 11.7014 18.6504 12.5914C18.9404 12.8814 19.4204 12.8914 19.7104 12.5914C20.0004 12.3014 20.0104 11.8214 19.7104 11.5314C18.6904 10.5014 17.4804 9.69139 16.1404 9.13139C14.8004 8.57139 13.3704 8.29139 11.9304 8.29139C10.8104 8.29139 9.70043 8.46139 8.64043 8.79139L6.62043 6.77139C6.62043 6.77139 6.68043 6.74139 6.72043 6.73139C8.37043 6.05139 10.1404 5.69139 11.9204 5.69139C13.7004 5.69139 15.4704 6.04139 17.1204 6.73139C18.7704 7.41139 20.2704 8.42139 21.5304 9.68139C21.8204 9.97139 22.3004 9.97139 22.5904 9.68139C22.8804 9.39139 22.8804 8.91139 22.5904 8.62139C21.1904 7.22139 19.5204 6.11139 17.6904 5.35139C15.8604 4.59139 13.8904 4.20139 11.9104 4.20139C9.93043 4.20139 7.96043 4.59139 6.13043 5.35139C5.91043 5.44139 5.69043 5.54139 5.47043 5.64139L2.28043 2.45139ZM3.41043 7.73139C3.67043 8.05139 3.63043 8.52139 3.30043 8.79139C2.95043 9.08139 2.61043 9.38139 2.29043 9.70139C2.00043 9.99139 1.52043 9.99139 1.23043 9.70139C0.94043 9.41139 0.94043 8.93139 1.23043 8.64139C1.59043 8.28139 1.96043 7.95139 2.35043 7.63139C2.67043 7.37139 3.14043 7.41139 3.41043 7.74139V7.73139ZM6.14043 11.7714C6.47043 11.5214 6.53043 11.0514 6.28043 10.7214C6.03043 10.3914 5.56043 10.3314 5.23043 10.5814C4.85043 10.8714 4.49043 11.1914 4.15043 11.5314C3.86043 11.8214 3.86043 12.3014 4.15043 12.5914C4.44043 12.8814 4.92043 12.8814 5.21043 12.5914C5.50043 12.2914 5.82043 12.0214 6.14043 11.7714V11.7714ZM9.24043 13.7214C9.49043 14.0514 9.43043 14.5214 9.10043 14.7714C8.92043 14.9114 8.75043 15.0614 8.59043 15.2214C8.30043 15.5214 7.83043 15.5214 7.53043 15.2314C7.23043 14.9414 7.23043 14.4714 7.52043 14.1714C7.73043 13.9614 7.95043 13.7614 8.19043 13.5714C8.52043 13.3214 8.99043 13.3814 9.24043 13.7114V13.7214ZM11.9104 17.9914C11.1904 17.9914 10.6204 18.5714 10.6204 19.2814C10.6204 19.9914 11.2004 20.5714 11.9104 20.5714C12.6204 20.5714 13.2004 19.9914 13.2004 19.2814C13.2004 18.5714 12.6204 17.9914 11.9104 17.9914ZM9.12043 19.2814C9.12043 17.7414 10.3704 16.4914 11.9104 16.4914C13.4504 16.4914 14.7004 17.7414 14.7004 19.2814C14.7004 20.8214 13.4504 22.0714 11.9104 22.0714C10.3704 22.0714 9.12043 20.8214 9.12043 19.2814Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNoWifi.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNoWifi.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNoWifi.prototype, "size", void 0);
if (customElements.get('cat-icon-no-wifi') === undefined) {
    customElements.define('cat-icon-no-wifi', BlocksIconNoWifi);
}
